/* eslint-disable no-template-curly-in-string */
const config = {
  app: {
    urlServer: 'https://emitir-api.emissaoonline.com.br/api',
    urlServerPanel: 'https://apiemissaoweb.vaultid.com.br/',
    partnerNames: '["arsoluti", "ardigisec", "arobjectti", "arrp", "arpartner"]',
    skuBirdIdTrial: '2970',
    negociations: '["34333","34334", "34544"]',
    poolServer: '${VUE_APP_POOL_URL_SERVER}',
    vlineUrl: 'https://vline.soluti.com.br/',
    reCaptchaSiKey: '6LdgPN0qAAAAAK88wIV9jUeXwOkh3b07WY3-29Jt',
  },
  version: {
    commit: 'f0c9a76145b69d90b584139396900c7861f0054c',
    branch: '',
    tag: '2.31.3',
    repo: 'online-emission-frontend',
    build: '1126',
    date: '2026-11-03T21:51:20.1793742680Z',
  },
}

type Config = typeof config

export default config as Config
